module.exports = __webpack_public_path__ + "img/club-white.615772b1.png";